export default __webpack_public_path__ + "static/globe-light.png";